import WithSidebar from 'Layout/WithSidebar';
import BenefitsBox from 'components/BenefitsBox';
import GeneralInfoBox from 'components/GeneralInfoBox';
import NavigationSideBar from 'components/NavigationSideBar';
import NavigationSectionWrapper from 'components/NavigationSideBar/NavigationSectionWrapper';
import { calculateActiveIndex } from 'components/NavigationSideBar/helpers';
import PDFBox from 'components/PDFBox';
import PictureComponent from 'components/PictureComponent';
import ProductCatalogBox from 'components/ProductCatalogBox';
import CropNutritionBox from 'components/ProductItemsBox/CropNutritionBox';
import RelatedProductsBox from 'components/ProductItemsBox/RelatedProductsBox';
import ProductItemsBoxWithTabs from 'components/ProductItemsBox/TrialResultsBoxWithTabs';
import YoutubeLink from 'components/YoutubeLink';
import { createRef, useEffect, useState } from 'react';

const getContentByKey = (key, data) => {
    switch (key) {
        case 'general_information': {
            const { main_title, general_information, general_information_image } = data;
            return (
                <>
                    <GeneralInfoBox>
                        {main_title && <h3>{main_title}</h3>}
                        <div dangerouslySetInnerHTML={{ __html: general_information }}></div>
                        {/* TODO what about this button ? */}
                        {/* <Button type="read-more">READ MORE</Button> */}
                    </GeneralInfoBox>
                    {general_information_image && (
                        <PictureComponent srcBig={general_information_image} alt="info" className="pt-8" />
                    )}
                </>
            );
        }

        case 'benefits_data': {
            const { benefits_preview_video, benefits_preview_text, benefits_video } = data?.video || {};
            return (
                <BenefitsBox title={data?.main_title} data={data?.benefits}>
                    {benefits_video && (
                        <YoutubeLink
                            image={benefits_preview_video}
                            href={benefits_video}
                            title={benefits_preview_text}
                        />
                    )}
                </BenefitsBox>
            );
        }

        case 'composition_compatibility': {
            const { main_title, composition_compatibility } = data;
            return <PDFBox title={main_title} data={composition_compatibility} />;
        }
        case 'related_products': {
            return <RelatedProductsBox title={data.main_title} />;
        }
        case 'nutrition_programs':
            return <CropNutritionBox title={data.main_title} />;
        case 'trial_results':
            return <ProductItemsBoxWithTabs title={data.main_title} />;
        case 'catalog_0':
        case 'catalog_1':
        case 'catalog_2':
        case 'catalog_3':
        case 'catalog_4':
        case 'catalog_5':
        case 'catalog_6':
            return (
                <ProductCatalogBox
                    file={data.data.file}
                    title={data.main_title}
                    image={data.data.image}
                    description={data.data.description}
                />
            );
        default:
            return null;
    }
};

const checkIsValidData = (key, value) => {
    switch (key) {
        case 'general_information':
            return value.main_title !== null && value.general_information !== null;
        case 'benefits_data':
            return value !== null;
        case 'composition_compatibility':
            return value.length > 0;
        case 'related_products':
            return value?.main_title;
        case 'trial_results':
            return value?.main_title;
        case 'nutrition_programs':
            return value?.main_title;
        case 'catalog_0':
        case 'catalog_1':
        case 'catalog_2':
        case 'catalog_3':
        case 'catalog_4':
        case 'catalog_5':
        case 'catalog_6':
            return !!value.data.file;
        default:
            return true;
    }
};
// TODO NOT DONE!!!
const AboutProductPageContent = ({ pageContentData }) => {
    const [sectionsData, setSectionsData] = useState({});
    const [activeIndex, setActiveIndex] = useState(0);
    const pageContent = [];
    const sidebarTitles = [];

    Object.entries(pageContentData).forEach(([key, value]) => {
        // adjust this for empty blocks
        // if ((value && Object.keys(value).length !== 0) || value?.length) {
        if (checkIsValidData(key, value)) {
            pageContent.push(getContentByKey(key, value));
            sidebarTitles.push(value.main_title);
        }
    });

    const arrLength = pageContent.length;
    const [refs, setRefs] = useState([]);

    useEffect(() => {
        setRefs(refs =>
            Array(arrLength)
                .fill()
                .map((_, i) => refs[i] || createRef()),
        );
    }, [arrLength]);

    useEffect(() => {
        setActiveIndex(calculateActiveIndex(sectionsData));
    }, [sectionsData]);

    return (
        <WithSidebar Sidebar={<NavigationSideBar activeIndex={activeIndex} refs={refs} items={sidebarTitles} />}>
            {pageContent.map((item, index) => (
                <div ref={refs[index]} key={index}>
                    <NavigationSectionWrapper index={index} setData={setSectionsData}>
                        {item}
                    </NavigationSectionWrapper>
                </div>
            ))}
        </WithSidebar>
    );
};
export default AboutProductPageContent;
